import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const OPEN_OPENINGS_WIZARD = "@openingsWizard/OPEN";
export const CLOSE_OPENINGS_WIZARD = "@openingsWizard/CLOSE";

export const OpeningsWizardActions = {
  openModal: (payload: { estimateGroupId: number; parentProductId: number; estimateLineItemId?: number }) =>
    createAction(OPEN_OPENINGS_WIZARD, payload),
  closeModal: () => createAction(CLOSE_OPENINGS_WIZARD),
};

export type OpeningsWizardActions = ActionsUnion<typeof OpeningsWizardActions>;
